import axios from 'axios'

export const getPreferedMarketsByTerm = async (term, token, size) => {
  // Query for Application Form 'Initiativbewerbung'. Only for Denns Biomärkte and BMV with applicationEmail being set
  const url = `${process.env.GATSBY_API_MARKET_SEARCH}`
  const headers = { Authorization: `Bearer ${token}` }
  const params = { op: 'byPreferredTerm', term, size }
  const res = await axios({
    method: 'get',
    url,
    headers,
    params
  })

  const items = res.data.hits.hits.map(hit => ({
    marketData: hit._source,
    highlight: hit.highlight
  }))

  return {
    response: res,
    numberOfItems: res.data.hits.hits.length,
    result: items
  }
}
